import { isEmpty } from "lodash";
import React from "react";
import { NavLink } from "react-router-dom";
const BunnerCardProduct = ({
  title,
  color,
  price,
  info,
  link,
  btnTitleLink,
}) => {
  return (
    <div
      className={`card text-white mb-3 ml-3`}
      style={{ maxWidth: "12.6rem", backgroundColor: color }}
    >
      <div className="card-header text-bold ">{title}</div>
      <div className="card-body">
        <h5 className="card-title">{price}</h5>
        <p className="card-text text-justify ">{info}</p>
        <NavLink to={!isEmpty(link) ? link : "/"} className={`btn btn-info`}>
          {btnTitleLink}
        </NavLink>
      </div>
    </div>
  );
};

export default BunnerCardProduct;
